import { createContext, useContext } from "react";

export type ProfileContextData = {
  auth: boolean;
  name?: string;
  sector?: string;
  logo?: string;
  cover?: string;
  moodboards: { id: string; title: string; createdAt: number }[];
  bookmarks: { moodboardId: string; id: string }[];
  messages: {
    id: string;
    title: string;
    text: string;
    createdAt?: string;
    readAt?: string;
  }[];
};

const ProfileContext = createContext<ProfileContextData>({
  auth: false,
  moodboards: [],
  bookmarks: [],
  messages: [],
});

export const ProfileProvider = ProfileContext.Provider;

export const useProfile = () => useContext(ProfileContext);
